(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8576],{

/***/ 36948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vh": function() { return /* binding */ millisecondsInHour; },
/* harmony export */   "yJ": function() { return /* binding */ millisecondsInMinute; }
/* harmony export */ });
/* unused harmony exports daysInWeek, daysInYear, maxTime, millisecondsInSecond, minTime, minutesInHour, monthsInQuarter, monthsInYear, quartersInYear, secondsInHour, secondsInMinute, secondsInDay, secondsInWeek, secondsInYear, secondsInMonth, secondsInQuarter */
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;
/**
 * Days in 1 year
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * @name daysInYear
 * @constant
 * @type {number}
 * @default
 */

var daysInYear = 365.2425;
/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */

var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInHour = 3600000;
/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInSecond = 1000;
/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */

var minTime = -maxTime;
/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */

var minutesInHour = 60;
/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var monthsInQuarter = 3;
/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */

var monthsInYear = 12;
/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */

var quartersInYear = 4;
/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */

var secondsInHour = 3600;
/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var secondsInMinute = 60;
/**
 * Seconds in 1 day
 *
 * @name secondsInDay
 * @constant
 * @type {number}
 * @default
 */

var secondsInDay = secondsInHour * 24;
/**
 * Seconds in 1 week
 *
 * @name secondsInWeek
 * @constant
 * @type {number}
 * @default
 */

var secondsInWeek = secondsInDay * 7;
/**
 * Seconds in 1 year
 *
 * @name secondsInYear
 * @constant
 * @type {number}
 * @default
 */

var secondsInYear = secondsInDay * daysInYear;
/**
 * Seconds in 1 month
 *
 * @name secondsInMonth
 * @constant
 * @type {number}
 * @default
 */

var secondsInMonth = secondsInYear / 12;
/**
 * Seconds in 1 quarter
 *
 * @name secondsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var secondsInQuarter = secondsInMonth * 3;

/***/ }),

/***/ 2035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var AddToPlaylist = function AddToPlaylist(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#fff" : _ref$color;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 39 43",
    fill: "none",
    className: className,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("g", {
      filter: "url(#prefix__filter0_d_4411_9871)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M30.006 32.805c2.46 0 4.453-1.709 4.453-3.817 0-2.107-1.994-3.816-4.453-3.816-2.459 0-4.452 1.709-4.452 3.816 0 2.108 1.993 3.817 4.452 3.817zM9.652 37.893c2.459 0 4.452-1.709 4.452-3.817s-1.993-3.816-4.452-3.816c-2.46 0-4.453 1.708-4.453 3.816 0 2.108 1.994 3.817 4.453 3.817z",
        stroke: color,
        strokeWidth: 2.806,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.508 22.517a8.972 8.972 0 01-2.806 0v12.196a1.403 1.403 0 002.806 0V22.517zm7.278-10.79l10.27-2.568v20.465a1.403 1.403 0 002.806 0V7.363A1.403 1.403 0 0034.12 6l-12.4 3.1a8.85 8.85 0 011.067 2.625z",
        fill: color
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
        cx: 13.647,
        cy: 12.469,
        r: 9.423,
        stroke: color,
        strokeWidth: 2.525
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("g", {
        filter: "url(#prefix__filter1_d_4411_9871)",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.699 7.89V6.838h-2.105v4.58H8.015v2.104H12.594v4.58H14.7v-4.58H19.278v-2.104H14.7V7.89z",
          fill: color
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("filter", {
        id: "prefix__filter0_d_4411_9871",
        x: 0.722,
        y: 0.672,
        width: 37.379,
        height: 41.99,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feOffset", {
          dy: 1.128
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feGaussianBlur", {
          stdDeviation: 1.119
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_4411_9871"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_4411_9871",
          result: "shape"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("filter", {
        id: "prefix__filter1_d_4411_9871",
        x: 5.776,
        y: 5.727,
        width: 15.742,
        height: 15.742,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feOffset", {
          dy: 1.128
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feGaussianBlur", {
          stdDeviation: 1.119
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_4411_9871"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_4411_9871",
          result: "shape"
        })]
      })]
    })]
  });
};

var MemoAddToPlaylist = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(AddToPlaylist);
/* harmony default export */ __webpack_exports__["Z"] = (MemoAddToPlaylist);

/***/ }),

/***/ 96290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Wave_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54825);
/* harmony import */ var _Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Wave = function Wave(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 50 38.05",
    width: "1em",
    height: "1em"
  }, props), {}, {
    className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wave),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 1",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M.91 15H.78A1 1 0 000 16v6a1 1 0 102 0v-6a1 1 0 00-1-1H.91z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 2",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M6.91 9h-.13A1 1 0 006 10v18a1 1 0 102 0V10a1 1 0 00-1-1h-.09z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 3",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M12.91 0h-.13A1 1 0 0012 1v36a1 1 0 102 0V1a1 1 0 00-1-1h-.09z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 4",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M18.91 10h-.12a1 1 0 00-.79 1v16a1 1 0 102 0V11a1 1 0 00-1-1h-.09z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 5",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M24.91 15h-.12a1 1 0 00-.79 1v6a1 1 0 002 0v-6a1 1 0 00-1-1h-.09z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 6",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M30.91 10h-.12a1 1 0 00-.79 1v16a1 1 0 102 0V11a1 1 0 00-1-1h-.09z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 7",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M36.91 0h-.13A1 1 0 0036 1v36a1 1 0 102 0V1a1 1 0 00-1-1h-.09z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 8",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M42.91 9h-.13a1 1 0 00-.78 1v18a1 1 0 102 0V10a1 1 0 00-1-1h-.09z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      "data-name": "Line 9",
      className: (_Wave_module_scss__WEBPACK_IMPORTED_MODULE_3___default().path),
      d: "M48.91 15h-.12a1 1 0 00-.79 1v6a1 1 0 102 0v-6a1 1 0 00-1-1h-.09z"
    })]
  }));
};

var MemoWave = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Wave);
/* harmony default export */ __webpack_exports__["Z"] = (MemoWave);

/***/ }),

/***/ 16446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ player_wrapper_component; }
});

// EXTERNAL MODULE: ./app/store/slices/player.ts
var player = __webpack_require__(22564);
// EXTERNAL MODULE: ./app/store/store.ts
var store = __webpack_require__(4062);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./app/components/station-player/player.module.scss
var player_module = __webpack_require__(28635);
var player_module_default = /*#__PURE__*/__webpack_require__.n(player_module);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./app/components/icons/Play.tsx
var Play = __webpack_require__(43935);
// EXTERNAL MODULE: ./services-hooks/hooks.ts + 1 modules
var hooks = __webpack_require__(90413);
// EXTERNAL MODULE: ./app/components/icons/Pause.tsx
var Pause = __webpack_require__(82334);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useInterval.js
var useInterval = __webpack_require__(43337);
// EXTERNAL MODULE: ./app/hooks/spacebar.hook.ts
var spacebar_hook = __webpack_require__(28395);
// EXTERNAL MODULE: ./app/components/icons/Loader.tsx
var Loader = __webpack_require__(37387);
// EXTERNAL MODULE: ./app/hooks/favorites.hook.ts
var favorites_hook = __webpack_require__(18958);
// EXTERNAL MODULE: ./app/components/toast/toast.component.tsx + 1 modules
var toast_component = __webpack_require__(53483);
// EXTERNAL MODULE: ./app/context/player.context.tsx
var player_context = __webpack_require__(48346);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./app/hooks/go-back.hook.ts
var go_back_hook = __webpack_require__(71014);
// EXTERNAL MODULE: ./app/hooks/keyboard-navigation.hook.ts
var keyboard_navigation_hook = __webpack_require__(36158);
// EXTERNAL MODULE: ./app/store/slices/user.ts
var user = __webpack_require__(38886);
// EXTERNAL MODULE: ./services-hooks/config.ts + 5 modules
var config = __webpack_require__(48788);
// EXTERNAL MODULE: ./app/components/icons/AddToPlaylist.tsx
var AddToPlaylist = __webpack_require__(2035);
// EXTERNAL MODULE: ./app/components/icons/AngleDown.tsx
var AngleDown = __webpack_require__(37526);
// EXTERNAL MODULE: ./app/components/icons/HeartFull.tsx
var HeartFull = __webpack_require__(1919);
// EXTERNAL MODULE: ./app/components/icons/HeartOutline.tsx
var HeartOutline = __webpack_require__(9761);
// EXTERNAL MODULE: ./app/components/icons/Info.tsx
var Info = __webpack_require__(42924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./app/components/icons/SpotifyAdd.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var SpotifyAdd = function SpotifyAdd(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 90 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M36.193 32.306A23.044 23.044 0 0 0 41.143 18c0-2.362-.354-4.64-1.011-6.787a41.294 41.294 0 0 1 8.725-.927v.002C71.58 10.288 90 28.708 90 51.428c0 22.724-18.419 41.143-41.143 41.143-22.722 0-41.143-18.419-41.143-41.142 0-4.142.612-8.14 1.75-11.911A23.08 23.08 0 0 0 18 41.143a23.32 23.32 0 0 0 3.418-.25 3.85 3.85 0 0 0 3.977 1.105c12.66-3.842 34.538-3.118 47.798 4.758h.002a3.845 3.845 0 0 0 5.271-1.346 3.844 3.844 0 0 0-1.346-5.273c-11.278-6.695-27.41-8.91-40.927-7.831Zm28.004 38.17a2.563 2.563 0 0 0 3.528-.85 2.564 2.564 0 0 0-.85-3.528c-10.845-6.627-24.289-8.17-39.96-4.589a2.565 2.565 0 0 0 1.141 5.002c14.32-3.272 26.481-1.936 36.141 3.965Zm4.151-10.996a3.207 3.207 0 0 0 4.412-1.058 3.207 3.207 0 0 0-1.056-4.41c-12.7-7.804-31.275-10-46.217-5.467a3.212 3.212 0 0 0-2.14 4.001 3.212 3.212 0 0 0 4.004 2.137c13.08-3.97 29.938-2.002 40.998 4.797Z",
      fill: "#1ED760"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M36 18c0 9.941-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0s18 8.059 18 18Zm-27.515-.225a3.214 3.214 0 0 1 3.214-3.214h2.99V11.7a3.214 3.214 0 0 1 6.428 0v2.86h2.957a3.214 3.214 0 0 1 0 6.43h-2.957v3.085a3.214 3.214 0 0 1-6.428 0V20.99h-2.99a3.214 3.214 0 0 1-3.214-3.215Z",
      fill: "#fff"
    })]
  }));
};

var MemoSpotifyAdd = /*#__PURE__*/(0,react.memo)(SpotifyAdd);
/* harmony default export */ var icons_SpotifyAdd = (MemoSpotifyAdd);
// EXTERNAL MODULE: ./app/hooks/modal-scroll.hook.ts
var modal_scroll_hook = __webpack_require__(76299);
// EXTERNAL MODULE: ./app/components/station-player/player-fullscreen.module.scss
var player_fullscreen_module = __webpack_require__(15786);
var player_fullscreen_module_default = /*#__PURE__*/__webpack_require__.n(player_fullscreen_module);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 8 modules
var CSSTransition = __webpack_require__(41365);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useWindowSize.js + 1 modules
var useWindowSize = __webpack_require__(37345);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useNetworkState.js
var useNetworkState = __webpack_require__(6765);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useClickAway.js
var useClickAway = __webpack_require__(69293);
// EXTERNAL MODULE: ./app/components/stations-list/stations-row.component.tsx
var stations_row_component = __webpack_require__(99845);
;// CONCATENATED MODULE: ./app/components/icons/DeezerIcon.tsx


function DeezerIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DeezerIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DeezerIcon_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DeezerIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var DeezerIcon = function DeezerIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", DeezerIcon_objectSpread(DeezerIcon_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M37 14h-7.568v4.428H37V14z",
      fill: "#40AB5D"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M37 20.14h-7.568v4.427H37v-4.428z",
      fill: "url(#prefix__paint0_linear_2218_5666)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M37 26.278h-7.568v4.428H37v-4.428z",
      fill: "url(#prefix__paint1_linear_2218_5666)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M9.568 32.417H2v4.428h7.568v-4.428z",
      fill: "url(#prefix__paint2_linear_2218_5666)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M18.706 32.417h-7.568v4.428h7.568v-4.428z",
      fill: "url(#prefix__paint3_linear_2218_5666)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M27.862 32.417h-7.568v4.428h7.568v-4.428z",
      fill: "url(#prefix__paint4_linear_2218_5666)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M37 32.417h-7.568v4.428H37v-4.428z",
      fill: "url(#prefix__paint5_linear_2218_5666)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M27.862 26.278h-7.568v4.428h7.568v-4.428z",
      fill: "url(#prefix__paint6_linear_2218_5666)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M18.706 26.278h-7.568v4.428h7.568v-4.428z",
      fill: "url(#prefix__paint7_linear_2218_5666)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M18.706 20.14h-7.568v4.427h7.568v-4.428z",
      fill: "url(#prefix__paint8_linear_2218_5666)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 9A7 7 0 112 9a7 7 0 0114 0zM5.3 8.912c0-.69.56-1.25 1.25-1.25h1.163V6.55a1.25 1.25 0 112.5 0v1.112h1.15a1.25 1.25 0 010 2.5h-1.15v1.2a1.25 1.25 0 01-2.5 0v-1.2H6.55c-.69 0-1.25-.56-1.25-1.25z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint0_linear_2218_5666",
        x1: 33.253,
        y1: 24.605,
        x2: 33.182,
        y2: 20.074,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#358C7B"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.526,
          stopColor: "#33A65E"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint1_linear_2218_5666",
        x1: 29.321,
        y1: 30.479,
        x2: 37.115,
        y2: 26.507,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#222B90"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#367B99"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint2_linear_2218_5666",
        x1: 2.001,
        y1: 34.633,
        x2: 9.563,
        y2: 34.633,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#F90"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#FF8000"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint3_linear_2218_5666",
        x1: 11.147,
        y1: 34.633,
        x2: 18.708,
        y2: 34.633,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF8000"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#CC1953"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint4_linear_2218_5666",
        x1: 20.291,
        y1: 34.633,
        x2: 27.853,
        y2: 34.633,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#CC1953"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#241284"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint5_linear_2218_5666",
        x1: 29.428,
        y1: 34.633,
        x2: 36.99,
        y2: 34.633,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#222B90"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#3559A6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint6_linear_2218_5666",
        x1: 19.993,
        y1: 29.686,
        x2: 28.152,
        y2: 27.3,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#CC1953"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#241284"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint7_linear_2218_5666",
        x1: 10.877,
        y1: 27.019,
        x2: 18.977,
        y2: 29.967,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.003,
          stopColor: "#FC0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#CE1938"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "prefix__paint8_linear_2218_5666",
        x1: 11.782,
        y1: 19.451,
        x2: 18.073,
        y2: 25.256,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.003,
          stopColor: "#FFD100"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#FD5A22"
        })]
      })]
    })]
  }));
};

var MemoDeezerIcon = /*#__PURE__*/react.memo(DeezerIcon);
/* harmony default export */ var icons_DeezerIcon = (MemoDeezerIcon);
// EXTERNAL MODULE: ./app/components/icons/Playlist.tsx
var Playlist = __webpack_require__(41127);
// EXTERNAL MODULE: ./app/hooks/lang.ts + 22 modules
var lang = __webpack_require__(91289);
// EXTERNAL MODULE: ./app/hooks/navigation.hook.ts
var navigation_hook = __webpack_require__(26793);
// EXTERNAL MODULE: ./app/context/features.context.tsx
var features_context = __webpack_require__(10833);
// EXTERNAL MODULE: ./app/components/ui/button.component.tsx
var button_component = __webpack_require__(61947);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./app/components/station-player/vlyby-container.component.tsx
var vlyby_container_component = __webpack_require__(17812);
// EXTERNAL MODULE: ./app/context/country.context.tsx
var country_context = __webpack_require__(91537);
;// CONCATENATED MODULE: ./app/components/station-player/player-fullscreen.component.tsx











































var PlayerFullScreen = function PlayerFullScreen(_ref) {
  var _session$user4, _categoryMetadata$bod, _categoryMetadata$bod2, _categoryMetadata$bod3, _categoryMetadata$bod4, _categoryMetadata$bod5, _categoryMetadata$bod6, _categoryMetadata$bod7, _clsx2, _categoryMetadata$bod8, _categoryMetadata$bod9, _categoryMetadata$bod10, _categoryMetadata$bod11, _categoryMetadata$bod12, _categoryMetadata$bod13, _categoryMetadata$bod14, _categoryMetadata$bod15, _categoryMetadata$bod16, _categoryMetadata$bod17, _categoryMetadata$bod18, _categoryMetadata$bod19, _categoryMetadata$bod20, _categoryMetadata$bod21, _categoryMetadata$bod22, _categoryMetadata$bod23, _categoryMetadata$bod24, _categoryMetadata$bod25, _categoryMetadata$bod26, _categoryMetadata$bod27, _categoryMetadata$bod28, _categoryMetadata$bod29, _categoryMetadata$bod30;

  var playerCssVariables = _ref.playerCssVariables,
      category = _ref.category,
      onClose = _ref.onClose,
      playbackState = _ref.playbackState,
      playbackControls = _ref.playbackControls,
      categoryMetadata = _ref.categoryMetadata,
      goToDetails = _ref.goToDetails,
      cover = _ref.cover,
      open = _ref.open,
      backToHTTPS = _ref.backToHTTPS;

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      audioDotsEnabled = _useFeaturesContext.audioDotsEnabled,
      audioDotsPublisherId = _useFeaturesContext.audioDotsPublisherId,
      audioDotsChannelId = _useFeaturesContext.audioDotsChannelId,
      premiumVersion = _useFeaturesContext.premiumVersion,
      vlybyPublisherId = _useFeaturesContext.vlybyPublisherId;

  var _usePlayerContext = (0,player_context/* usePlayerContext */.gD)(),
      audioDots = _usePlayerContext.audioDots,
      checkGlobalTimer = _usePlayerContext.checkGlobalTimer,
      setGlobalAdCloseTime = _usePlayerContext.setGlobalAdCloseTime,
      globalAdCloseTime = _usePlayerContext.globalAdCloseTime,
      httpMode = _usePlayerContext.httpMode,
      priceData = _usePlayerContext.priceData;

  var navigatePath = (0,navigation_hook/* useNavigatePath */.xQ)();
  var t = (0,lang/* useTranslate */.q)();

  var _useFavorites = (0,favorites_hook/* useFavorites */.r)(function () {
    onClose();
    navigatePath("/log-in", true, {
      openplayer: true
    });
  }),
      toggleFavorite = _useFavorites.toggleFavorite,
      favoritesLoading = _useFavorites.loading,
      isFavoriteCategory = _useFavorites.isFavoriteCategory;

  var _useState = (0,react.useState)(false),
      videoAdActive = _useState[0],
      setVideoAdActive = _useState[1];

  var _useState2 = (0,react.useState)(false),
      sidebarOpen = _useState2[0],
      setSidebarOpen = _useState2[1];

  (0,modal_scroll_hook/* default */.Z)(open);

  var _usePostPillowSpotify = (0,hooks/* usePostPillowSpotifyV2SpotifyTrack_addRadio_id */.eN)(),
      addToSpotify = _usePostPillowSpotify.mutateAsync,
      spotifyLoading = _usePostPillowSpotify.isLoading;

  var _usePostPillowDeezerV = (0,hooks/* usePostPillowDeezerV2DeezerTrack_addRadio_id */.yF)(),
      addToDeezer = _usePostPillowDeezerV.mutateAsync,
      deezerLoading = _usePostPillowDeezerV.isLoading;

  var _useWindowSize = (0,useWindowSize/* default */.Z)(),
      width = _useWindowSize.width,
      height = _useWindowSize.height;

  var controlsContainerRef = (0,react.useRef)(null);

  var _useAppSelector = (0,store/* useAppSelector */.CG)(user/* selectUserState */.tH),
      session = _useAppSelector.session;

  var _useToasts = (0,toast_component/* useToasts */.e1)({
    success: t("playlsit.spotify-success"),
    error: t("playlsit.spotify-error")
  }),
      _useToasts2 = (0,slicedToArray/* default */.Z)(_useToasts, 2),
      showSpotifySuccess = _useToasts2[0],
      showSpotifyError = _useToasts2[1];

  var _useToasts3 = (0,toast_component/* useToasts */.e1)({
    success: t("playlsit.deezer-success"),
    error: t("playlsit.deezer-error")
  }),
      _useToasts4 = (0,slicedToArray/* default */.Z)(_useToasts3, 2),
      showDeezerSuccess = _useToasts4[0],
      showDeezerError = _useToasts4[1];

  var httpModeToast = (0,toast_component/* useToast */.pm)({
    content: "Updating the player..."
  });
  var isAddToPlaylistLoading = spotifyLoading || deezerLoading;
  var goBackCallback = (0,react.useCallback)(function () {
    onClose();
  }, [onClose]);
  (0,go_back_hook/* useGoBackEvent */.H)("PlayerFullScreen", goBackCallback, open && !sidebarOpen);

  var addToPlaylist = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _session$user, _session$user2, _session$user3;

      var response, _e$response, error, _response, _e$response2, _error;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(session !== null && session !== void 0 && (_session$user = session.user) !== null && _session$user !== void 0 && _session$user.spotify_connect)) {
                _context.next = 13;
                break;
              }

              _context.prev = 1;
              _context.next = 4;
              return addToSpotify({
                radio_id: category.permalink
              });

            case 4:
              response = _context.sent;

              if (response && response.data && response.data.data && response.data.data.message) {
                showSpotifySuccess(response.data.data.message);
              } else {
                showSpotifySuccess();
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);

              if (_context.t0 instanceof config/* RequestError */.L) {
                error = (_e$response = _context.t0.response) === null || _e$response === void 0 ? void 0 : _e$response.data.errors[0];
                showSpotifyError(error.message);
              }

            case 11:
              _context.next = 27;
              break;

            case 13:
              if (!(session !== null && session !== void 0 && (_session$user2 = session.user) !== null && _session$user2 !== void 0 && _session$user2.deezer_connect)) {
                _context.next = 26;
                break;
              }

              _context.prev = 14;
              _context.next = 17;
              return addToDeezer({
                radio_id: category.permalink
              });

            case 17:
              _response = _context.sent;

              if (_response && _response.data && _response.data.data && _response.data.data.message) {
                showDeezerSuccess(_response.data.data.message);
              } else {
                showDeezerError();
              }

              _context.next = 24;
              break;

            case 21:
              _context.prev = 21;
              _context.t1 = _context["catch"](14);

              if (_context.t1 instanceof config/* RequestError */.L) {
                _error = (_e$response2 = _context.t1.response) === null || _e$response2 === void 0 ? void 0 : _e$response2.data.errors[0];
                showSpotifyError(_error.message);
              }

            case 24:
              _context.next = 27;
              break;

            case 26:
              if (!(session !== null && session !== void 0 && (_session$user3 = session.user) !== null && _session$user3 !== void 0 && _session$user3.premium)) {
                navigatePath("/get-premium", true, {
                  redirect: "/settings?accountlink=true"
                });
                onClose();
              } else {
                navigatePath("/settings");
                onClose();
              }

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8], [14, 21]]);
    }));

    return function addToPlaylist() {
      return _ref2.apply(this, arguments);
    };
  }();

  var wrapperRef = (0,keyboard_navigation_hook/* useArrowKeyNavigationOverlay */.Sy)(open);

  var renderAddToPlaylistIcon = function renderAddToPlaylistIcon() {
    if (session !== null && session !== void 0 && session.user) {
      if (session.user.spotify_connect) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(icons_SpotifyAdd, {});
      } else if (session.user.deezer_connect) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(icons_DeezerIcon, {});
      }
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(AddToPlaylist/* default */.Z, {});
  };

  var _useState3 = (0,react.useState)(null),
      audioDotPlayer = _useState3[0],
      setAudioDotPlayer = _useState3[1]; // const tryVidoeAdsPlayback = () => {
  //   if (audioDots.playerConstructor) {
  //     const { desiredHeight, desiredWidth } = getAdContainerMaximumSize();
  //     const adConfig = {
  //       publisherId: audioDotsPublisherId,
  //       channelId: audioDotsChannelId,
  //       ref1: "",
  //       height: desiredHeight,
  //       width: desiredWidth,
  //       autoPlay: true,
  //       loop: true,
  //       vastRetry: 3,
  //       errorLimit: 5,
  //       soundButton: false,
  //       pauseButton: false,
  //       midRollTime: 2,
  //       position: "ad_player_radio",
  //     };
  //     const player = new audioDots.playerConstructor(adConfig);
  //     setAudioDotPlayer(player);
  //     player.on("AdImpression", (e: any) => {
  //       setVideoAdActive(true);
  //     });
  //     player.on("AdVideoComplete", () => {
  //       setVideoAdActive(false);
  //       player.close();
  //       stopVideoAds();
  //     });
  //     player.play(adConfig);
  //   }
  // };


  var stopVideoAds = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setVideoAdActive(false);
              _context2.next = 3;
              return audioDotPlayer === null || audioDotPlayer === void 0 ? void 0 : audioDotPlayer.close();

            case 3:
              setAudioDotPlayer(null);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function stopVideoAds() {
      return _ref3.apply(this, arguments);
    };
  }();

  var videoAdsEnabled = audioDotsEnabled && !!audioDots && !premiumVersion && !(session !== null && session !== void 0 && (_session$user4 = session.user) !== null && _session$user4 !== void 0 && _session$user4.premium) && open; // useInterval(
  //   async () => {
  //     console.log("++++interval", new Date());
  //     if (!videoAdActive) {
  //       if (audioDotPlayer) {
  //         stopVideoAds();
  //         await timeout(2000);
  //       }
  //       tryVidoeAdsPlayback();
  //     }
  //   },
  //   videoAdsEnabled ? 5 * 60000 : null
  // );
  // VLYBY

  var networkState = (0,useNetworkState/* default */.Z)();
  var enableVlyby = !!vlybyPublisherId && !premiumVersion;

  var _useCountryContext = (0,country_context/* useCountryContext */.o)(),
      country = _useCountryContext.country;

  var _useState4 = (0,react.useState)(false),
      isVlybyAdReady = _useState4[0],
      setIsVlybyAdReady = _useState4[1];

  var _useState5 = (0,react.useState)(true),
      isFirstVlybyAdPlay = _useState5[0],
      setIsFirstVlybyAdPlay = _useState5[1];

  var getIsPageVisible = (0,react.useCallback)(function () {
    if (true) {
      return window.document.visibilityState === "visible";
    }

    return true;
  }, [window]);

  var _useState6 = (0,react.useState)(false),
      isAdblockDetected = _useState6[0],
      setIsAdblockDetected = _useState6[1];

  var hideAdTimeoutId = (0,react.useRef)(null);
  var showAdTimeoutId = (0,react.useRef)(null);
  var adFreeTime = 3 * 60000; //3min

  var firstAudioAdTimeout = 30000; //30s

  (0,react.useEffect)(function () {
    try {
      if (true) {
        window.innerHideVlybyPlayer = function () {
          stopVlybyVideoAds(window.isVlybyAdReady);
        };

        window.innerVlybyAdReady = function () {
          window.isVlybyAdReady = true;
          setIsVlybyAdReady(true);
        };
      }
    } catch (error) {}

    return function () {
      try {
        if (true) {
          delete window.innerHideVlybyPlayer;
          delete window.innerVlybyAdReady;
          delete window.isVlybyAdReady;
        }
      } catch (error) {}
    };
  }, []);

  var stopVlybyVideoAds = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var isSuccess,
          stopNextTimeout,
          isAdError,
          _args3 = arguments;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              isSuccess = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
              stopNextTimeout = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : false;
              isAdError = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : false;
              clearTimeout(hideAdTimeoutId.current);
              clearTimeout(showAdTimeoutId.current);
              window.isVlybyAdReady = false;
              setIsVlybyAdReady(false);
              setVideoAdActive(false);
              setShowVlyby(false);

              if (isSuccess) {
                setGlobalAdCloseTime(Number(Date.now()));
              }

              if (enableVlyby && !stopNextTimeout) {
                showAdTimeoutId.current = setTimeout(function () {
                  startLoadingVlyby();
                }, isAdError ? player_context/* VLYBY_AD_ERROR_TIMEOUT */.Ld : adFreeTime);
              }

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function stopVlybyVideoAds() {
      return _ref4.apply(this, arguments);
    };
  }(); // test adblock


  (0,react.useEffect)(function () {
    if (true) {
      var _window$getComputedSt;

      var adBoxEl = window.document.querySelector(".ad-box");
      setIsAdblockDetected(!!adBoxEl && ((_window$getComputedSt = window.getComputedStyle(adBoxEl)) === null || _window$getComputedSt === void 0 ? void 0 : _window$getComputedSt.display) === "none");
    }
  }, []);

  var _useState7 = (0,react.useState)(false),
      showVlyby = _useState7[0],
      setShowVlyby = _useState7[1];

  var startLoadingVlyby = function startLoadingVlyby() {
    if (!videoAdActive) {
      var _session$user5;

      clearTimeout(hideAdTimeoutId.current);
      var localCheck = enableVlyby && country.countryCode !== "de" && getIsPageVisible() && !(session !== null && session !== void 0 && (_session$user5 = session.user) !== null && _session$user5 !== void 0 && _session$user5.premium) && !isAdblockDetected;
      console.log("[[VLYBY]] START LOADING", localCheck, {
        open: open,
        isFirstVlybyAdPlay: isFirstVlybyAdPlay,
        globalAdCloseTime: globalAdCloseTime
      });
      setShowVlyby(localCheck);
      setVideoAdActive(localCheck);

      if (localCheck) {
        clearTimeout(hideAdTimeoutId.current);
        hideAdTimeoutId.current = setTimeout(function () {
          if (true) {
            console.log("[[VLYBY]] timeout", hideTimeout, isVlybyAdReady, window.isVlybyAdReady, showVlyby, localCheck);

            if (!window.isVlybyAdReady) {
              stopVlybyVideoAds(false, false, true);
            }
          }
        }, hideTimeout);
      } else {
        stopVlybyVideoAds();
      }
    }
  };

  var hideTimeout = (0,react.useMemo)(function () {
    if (networkState.effectiveType) {
      if (["2g", "slow-2g"].includes(networkState.effectiveType)) {
        return 30000;
      }

      if (["3g"].includes(networkState.effectiveType)) {
        return 15000;
      }
    }

    return 10000;
  }, [networkState]); // start loading vlyby

  (0,react.useEffect)(function () {
    clearTimeout(hideAdTimeoutId.current);
    clearTimeout(showAdTimeoutId.current);

    if (enableVlyby && open && isFirstVlybyAdPlay) {
      // first ad after 30s
      showAdTimeoutId.current = setTimeout(function () {
        setIsFirstVlybyAdPlay(false);
        startLoadingVlyby();
      }, checkGlobalTimer() ? firstAudioAdTimeout : player_context/* VLYBY_TIMEOUT */.UU - (Number(Date.now()) - globalAdCloseTime) + 10);
    } else if (enableVlyby && !open) {
      window.isVlybyAdReady = false;
      setIsVlybyAdReady(false);
      setVideoAdActive(false);
      setShowVlyby(false);
      setIsFirstVlybyAdPlay(true);
    }
  }, [open]);
  var showTopRightArtWork = ((categoryMetadata === null || categoryMetadata === void 0 ? void 0 : (_categoryMetadata$bod = categoryMetadata.body) === null || _categoryMetadata$bod === void 0 ? void 0 : (_categoryMetadata$bod2 = _categoryMetadata$bod.content) === null || _categoryMetadata$bod2 === void 0 ? void 0 : (_categoryMetadata$bod3 = _categoryMetadata$bod2.show) === null || _categoryMetadata$bod3 === void 0 ? void 0 : _categoryMetadata$bod3.image) || (categoryMetadata === null || categoryMetadata === void 0 ? void 0 : (_categoryMetadata$bod4 = categoryMetadata.body) === null || _categoryMetadata$bod4 === void 0 ? void 0 : (_categoryMetadata$bod5 = _categoryMetadata$bod4.content) === null || _categoryMetadata$bod5 === void 0 ? void 0 : (_categoryMetadata$bod6 = _categoryMetadata$bod5.track) === null || _categoryMetadata$bod6 === void 0 ? void 0 : (_categoryMetadata$bod7 = _categoryMetadata$bod6.album) === null || _categoryMetadata$bod7 === void 0 ? void 0 : _categoryMetadata$bod7.cover)) && category.logo;
  (0,react.useEffect)(function () {
    if (!videoAdsEnabled) {
      stopVideoAds();
    }
  }, [videoAdsEnabled]);

  var getAdContainerMaximumSize = function getAdContainerMaximumSize() {
    var _controlsContainerRef;

    var maximumHeight = window.innerHeight - 252 - (((_controlsContainerRef = controlsContainerRef.current) === null || _controlsContainerRef === void 0 ? void 0 : _controlsContainerRef.clientHeight) || 0);
    var proportionalMaximumWidth = maximumHeight * (16 / 9);
    var maximumWidth = proportionalMaximumWidth > 960 ? 960 : proportionalMaximumWidth;
    var desiredWidth = window.innerWidth - 80 > maximumWidth ? maximumWidth : window.innerWidth - 80;
    var desiredHeight = desiredWidth * (9 / 16);
    return {
      desiredHeight: desiredHeight,
      desiredWidth: desiredWidth
    };
  };

  var _useState8 = (0,react.useState)(""),
      adPlayerWidth = _useState8[0],
      setAdPlayerWidth = _useState8[1];

  var _useState9 = (0,react.useState)(""),
      adPlayerHeight = _useState9[0],
      setAdPlayerHeight = _useState9[1];

  (0,react.useEffect)(function () {
    if (audioDotPlayer || enableVlyby) {
      var _getAdContainerMaximu = getAdContainerMaximumSize(),
          desiredHeight = _getAdContainerMaximu.desiredHeight,
          desiredWidth = _getAdContainerMaximu.desiredWidth; // if (audioDotPlayer) {
      //   audioDotPlayer.resize(desiredWidth, desiredHeight);
      // }


      if (enableVlyby) {
        setAdPlayerWidth("".concat(desiredWidth, "px"));
        setAdPlayerHeight("".concat(desiredHeight, "px"));
      }
    }
  }, [width, height]);
  var closeSidebarCallback = (0,react.useCallback)(function () {
    return setSidebarOpen(false);
  }, [setSidebarOpen]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
    nodeRef: wrapperRef,
    in: open,
    timeout: httpMode ? 0 : 400,
    classNames: {
      enterActive: (player_fullscreen_module_default()).player_fullscreen_enter_active,
      enter: (player_fullscreen_module_default()).player_fullscreen_enter,
      enterDone: (player_fullscreen_module_default()).player_fullscreen_enter_done,
      exit: (player_fullscreen_module_default()).player_fullscreen_exit,
      exitActive: (player_fullscreen_module_default()).player_fullscreen_exit_active,
      exitDone: (player_fullscreen_module_default()).player_fullscreen_exit_done
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (player_fullscreen_module_default()).player_fullscreen,
      ref: wrapperRef,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (player_fullscreen_module_default()).player_fullscreen_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (player_fullscreen_module_default()).player_fullscreen_content,
          style: playerCssVariables,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (player_fullscreen_module_default()).player_fullscreen_inner,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (player_fullscreen_module_default()).player_fullscreen_header,
              "data-navigate-row": open,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                onClick: function onClick() {
                  if (httpMode && backToHTTPS) {
                    backToHTTPS("close");
                  } else {
                    onClose();
                  }
                },
                className: (player_fullscreen_module_default()).player_fullscreen_close,
                "data-navigate-item": open,
                "data-navigate-noscroll": true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(AngleDown/* default */.Z, {})
              }), (videoAdsEnabled || showVlyby || showTopRightArtWork) && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: (0,clsx_m/* default */.Z)((player_fullscreen_module_default()).player_logo, (0,defineProperty/* default */.Z)({}, (player_fullscreen_module_default()).ad_visible, videoAdActive && window.isVlybyAdReady)),
                src: category.logo,
                alt: ""
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (0,clsx_m/* default */.Z)((player_fullscreen_module_default()).player_fullscreen_track, (_clsx2 = {}, (0,defineProperty/* default */.Z)(_clsx2, (player_fullscreen_module_default()).video_ad, videoAdsEnabled || showVlyby), (0,defineProperty/* default */.Z)(_clsx2, (player_fullscreen_module_default()).invisible, !videoAdActive && !showVlyby), (0,defineProperty/* default */.Z)(_clsx2, (player_fullscreen_module_default()).video_ad_ready, window.isVlybyAdReady), _clsx2)),
              children: [window.isVlybyAdReady && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (player_fullscreen_module_default()).video_ad_header,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                    href: "/get-premium",
                    passHref: true,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      "data-navigate-row": videoAdActive || showVlyby,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_component/* Button */.zx, {
                        accent: true,
                        "data-navigate-item": videoAdActive || showVlyby,
                        "data-navigate-noscroll": true,
                        className: (player_fullscreen_module_default()).premium_button,
                        onClick: function onClick() {
                          return onClose();
                        },
                        children: t("premium.go-premium-for", {
                          var1: "".concat(priceData.amount).concat(priceData.currency_symbol)
                        })
                      })
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (player_fullscreen_module_default()).ad_header,
                  children: t("premium.video-ad-description")
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (player_fullscreen_module_default()).ad_player,
                style: {
                  display: !audioDotPlayer && !showVlyby ? "none" : undefined,
                  margin: "0px auto",
                  maxWidth: "853px"
                },
                children: showVlyby ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (player_fullscreen_module_default()).vlyby_container,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(vlyby_container_component/* VlybyContainer */.L, {
                    width: adPlayerWidth,
                    height: adPlayerHeight
                  })
                }) : audioDotsEnabled && videoAdActive ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  id: "ad_player_radio"
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (0,clsx_m/* default */.Z)((player_fullscreen_module_default()).player_fullscreen_track, (0,defineProperty/* default */.Z)({}, (player_fullscreen_module_default()).invisible, window.isVlybyAdReady)),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: cover,
                alt: ""
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (player_fullscreen_module_default()).player_fullscreen_track_info,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                  className: (player_fullscreen_module_default()).title,
                  children: category.name
                }), (categoryMetadata === null || categoryMetadata === void 0 ? void 0 : (_categoryMetadata$bod8 = categoryMetadata.body) === null || _categoryMetadata$bod8 === void 0 ? void 0 : (_categoryMetadata$bod9 = _categoryMetadata$bod8.content) === null || _categoryMetadata$bod9 === void 0 ? void 0 : (_categoryMetadata$bod10 = _categoryMetadata$bod9.show) === null || _categoryMetadata$bod10 === void 0 ? void 0 : _categoryMetadata$bod10.name) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (0,clsx_m/* default */.Z)((player_fullscreen_module_default()).show_name),
                  children: categoryMetadata === null || categoryMetadata === void 0 ? void 0 : (_categoryMetadata$bod11 = categoryMetadata.body) === null || _categoryMetadata$bod11 === void 0 ? void 0 : (_categoryMetadata$bod12 = _categoryMetadata$bod11.content) === null || _categoryMetadata$bod12 === void 0 ? void 0 : (_categoryMetadata$bod13 = _categoryMetadata$bod12.show) === null || _categoryMetadata$bod13 === void 0 ? void 0 : _categoryMetadata$bod13.name
                }), (categoryMetadata === null || categoryMetadata === void 0 ? void 0 : (_categoryMetadata$bod14 = categoryMetadata.body) === null || _categoryMetadata$bod14 === void 0 ? void 0 : (_categoryMetadata$bod15 = _categoryMetadata$bod14.content) === null || _categoryMetadata$bod15 === void 0 ? void 0 : (_categoryMetadata$bod16 = _categoryMetadata$bod15.track) === null || _categoryMetadata$bod16 === void 0 ? void 0 : _categoryMetadata$bod16.name) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (0,clsx_m/* default */.Z)((player_fullscreen_module_default()).track_name),
                  children: categoryMetadata === null || categoryMetadata === void 0 ? void 0 : (_categoryMetadata$bod17 = categoryMetadata.body) === null || _categoryMetadata$bod17 === void 0 ? void 0 : (_categoryMetadata$bod18 = _categoryMetadata$bod17.content) === null || _categoryMetadata$bod18 === void 0 ? void 0 : (_categoryMetadata$bod19 = _categoryMetadata$bod18.track) === null || _categoryMetadata$bod19 === void 0 ? void 0 : _categoryMetadata$bod19.name
                }), (categoryMetadata === null || categoryMetadata === void 0 ? void 0 : (_categoryMetadata$bod20 = categoryMetadata.body) === null || _categoryMetadata$bod20 === void 0 ? void 0 : (_categoryMetadata$bod21 = _categoryMetadata$bod20.content) === null || _categoryMetadata$bod21 === void 0 ? void 0 : (_categoryMetadata$bod22 = _categoryMetadata$bod21.track) === null || _categoryMetadata$bod22 === void 0 ? void 0 : (_categoryMetadata$bod23 = _categoryMetadata$bod22.artist) === null || _categoryMetadata$bod23 === void 0 ? void 0 : _categoryMetadata$bod23.name) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (0,clsx_m/* default */.Z)((player_fullscreen_module_default()).track_artist),
                  children: categoryMetadata === null || categoryMetadata === void 0 ? void 0 : (_categoryMetadata$bod24 = categoryMetadata.body) === null || _categoryMetadata$bod24 === void 0 ? void 0 : (_categoryMetadata$bod25 = _categoryMetadata$bod24.content) === null || _categoryMetadata$bod25 === void 0 ? void 0 : (_categoryMetadata$bod26 = _categoryMetadata$bod25.track) === null || _categoryMetadata$bod26 === void 0 ? void 0 : (_categoryMetadata$bod27 = _categoryMetadata$bod26.artist) === null || _categoryMetadata$bod27 === void 0 ? void 0 : _categoryMetadata$bod27.name
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)((player_fullscreen_module_default()).player_fullscreen_track_info, (player_fullscreen_module_default()).player_fullscreen_track_info_ads),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (0,clsx_m/* default */.Z)((player_fullscreen_module_default()).show_name),
                  children: (categoryMetadata === null || categoryMetadata === void 0 ? void 0 : (_categoryMetadata$bod28 = categoryMetadata.body) === null || _categoryMetadata$bod28 === void 0 ? void 0 : (_categoryMetadata$bod29 = _categoryMetadata$bod28.content) === null || _categoryMetadata$bod29 === void 0 ? void 0 : (_categoryMetadata$bod30 = _categoryMetadata$bod29.show) === null || _categoryMetadata$bod30 === void 0 ? void 0 : _categoryMetadata$bod30.name) || category.name
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (player_fullscreen_module_default()).player_fullscreen_controls,
              "data-navigate-row": open,
              ref: controlsContainerRef,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                "data-navigate-item": open,
                className: (player_fullscreen_module_default()).button_secondary,
                "data-navigate-noscroll": true,
                onClick: goToDetails,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Info/* default */.Z, {})
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                "data-navigate-item": open,
                "data-navigate-noscroll": true,
                className: (0,clsx_m/* default */.Z)((player_fullscreen_module_default()).button_priamry, (player_fullscreen_module_default()).heart),
                onClick: function onClick() {
                  return toggleFavorite(category, playbackState.playing);
                },
                children: favoritesLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : isFavoriteCategory(category) ? /*#__PURE__*/(0,jsx_runtime.jsx)(HeartFull/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(HeartOutline/* default */.Z, {})
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                "data-navigate-item": open,
                "data-navigate-noscroll": true,
                className: (0,clsx_m/* default */.Z)((player_fullscreen_module_default()).play, (0,defineProperty/* default */.Z)({}, (player_fullscreen_module_default()).show_play, !playbackState.playing)),
                onClick: function onClick() {
                  if (!playbackState.loading) {
                    playbackControls.toggle();
                  }
                },
                children: playbackState.loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: playbackState.playing ? /*#__PURE__*/(0,jsx_runtime.jsx)(Pause/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(Play/* default */.Z, {})
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: (0,clsx_m/* default */.Z)((player_fullscreen_module_default()).button_priamry, (player_fullscreen_module_default()).add_to_playlist_icon),
                onClick: function onClick() {
                  return addToPlaylist();
                },
                "data-navigate-noscroll": true,
                "data-navigate-item": open,
                children: isAddToPlaylistLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : renderAddToPlaylistIcon()
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: (0,clsx_m/* default */.Z)((player_fullscreen_module_default()).button_secondary, (player_fullscreen_module_default()).playlist_icon),
                "data-navigate-item": open,
                "data-navigate-noscroll": true,
                onClick: function onClick() {
                  return setSidebarOpen(true);
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Playlist/* default */.Z, {})
              })]
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PlayerSidebar, {
        open: sidebarOpen,
        onClose: closeSidebarCallback
      })]
    })
  });
};

var PlayerSidebar = function PlayerSidebar(_ref5) {
  var open = _ref5.open,
      onClose = _ref5.onClose;

  var _useAppSelector2 = (0,store/* useAppSelector */.CG)(player/* selectPlayerState */.tA),
      radioQueue = _useAppSelector2.radioQueue;

  var dispatch = (0,store/* useAppDispatch */.TL)();
  var sidebarRef = (0,keyboard_navigation_hook/* useArrowKeyNavigationOverlay */.Sy)(open);
  (0,useClickAway/* default */.Z)(sidebarRef, function (e) {
    onClose();
  });
  var goBackCallback = (0,react.useCallback)(function () {
    onClose();
  }, [onClose]);
  (0,go_back_hook/* useGoBackEvent */.H)("PlayerSidebar", goBackCallback, open);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
    nodeRef: sidebarRef,
    in: open,
    timeout: 400,
    classNames: {
      enterActive: (player_fullscreen_module_default()).player_sidebar_enter_active,
      enter: (player_fullscreen_module_default()).player_sidebar_enter,
      enterDone: (player_fullscreen_module_default()).player_sidebar_enter_done,
      exit: (player_fullscreen_module_default()).player_sidebar_exit,
      exitActive: (player_fullscreen_module_default()).player_sidebar_exit_active,
      exitDone: (player_fullscreen_module_default()).player_sidebar_exit_done
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (player_fullscreen_module_default()).player_sidebar,
      ref: sidebarRef,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (player_fullscreen_module_default()).player_sidebar_inner,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(stations_row_component/* StationsRow */.F, {
          column: true,
          handleOnClick: function handleOnClick(_, index) {
            dispatch(player/* playerActions.setRadioQueue */.i9.setRadioQueue({
              items: radioQueue.items,
              activeIndex: index
            }));
            onClose();
          },
          items: radioQueue.items,
          showStationNames: true,
          navigationDisabled: !open
        })
      })
    })
  });
};
// EXTERNAL MODULE: ./services-hooks/services.ts + 1 modules
var services = __webpack_require__(46725);
// EXTERNAL MODULE: ./app/components/icons/Wave.tsx
var Wave = __webpack_require__(96290);
// EXTERNAL MODULE: ./app/utils/audioAds.ts
var audioAds = __webpack_require__(21075);
// EXTERNAL MODULE: ./app/hooks/audio.hook.ts + 1 modules
var audio_hook = __webpack_require__(54008);
// EXTERNAL MODULE: ./app/model/category.ts
var model_category = __webpack_require__(51027);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./app/components/station-player/player.component.tsx
































var StationPlayer = function StationPlayer(_ref) {
  var _liveData$data$body, _liveData$data$body$c, _liveData$data$body$c2, _liveData$data$body2, _liveData$data$body2$, _liveData$data$body2$2, _liveData$data$body3, _liveData$data$body3$, _liveData$data$body3$2, _liveData$data$body3$3, _liveData$data7, _liveData$data7$body, _state$activeStream2;

  var category = _ref.category,
      playerOpen = _ref.playerOpen,
      setPlayerOpen = _ref.setPlayerOpen,
      streams = _ref.streams,
      adStreams = _ref.adStreams,
      streamsLoadError = _ref.streamsLoadError,
      refetchStreams = _ref.refetchStreams,
      streamsLoading = _ref.streamsLoading,
      sendTargetspotTimeUpdateEvent = _ref.sendTargetspotTimeUpdateEvent,
      sendTargetspotTrackingEvent = _ref.sendTargetspotTrackingEvent,
      sendTargetspotStateUpdateEvent = _ref.sendTargetspotStateUpdateEvent;
  var navigatePath = (0,navigation_hook/* useNavigatePath */.xQ)();
  var t = (0,lang/* useTranslate */.q)();
  var queryClient = (0,es.useQueryClient)();

  var _useState = (0,react.useState)(),
      liveData = _useState[0],
      setLiveData = _useState[1];

  var _useGetPillowRadioLiv = (0,hooks/* useGetPillowRadioLive */.pE)(category.permalink, {
    isPlaying: false
  }),
      updatedLiveData = _useGetPillowRadioLiv.data,
      refetch = _useGetPillowRadioLiv.refetch;

  var dispatch = (0,store/* useAppDispatch */.TL)();

  var _useAppSelector = (0,store/* useAppSelector */.CG)(user/* selectUserState */.tH),
      session = _useAppSelector.session;

  var _usePlayerContext = (0,player_context/* usePlayerContext */.gD)(),
      playerEnabled = _usePlayerContext.playerEnabled,
      isPlaying = _usePlayerContext.isPlaying,
      fullscreenPlayerInitialyOpen = _usePlayerContext.fullscreenPlayerInitialyOpen,
      setFullscreenPlayerInitialyOpen = _usePlayerContext.setFullscreenPlayerInitialyOpen,
      setIsMediaLoading = _usePlayerContext.setIsMediaLoading,
      setPlayerEnabled = _usePlayerContext.setPlayerEnabled,
      setIsPlaying = _usePlayerContext.setIsPlaying,
      httpMode = _usePlayerContext.httpMode,
      refetchMetadataInterval = _usePlayerContext.refetchMetadataInterval;

  var _useFeaturesContext = (0,features_context/* useFeaturesContext */.Pp)(),
      isHTTPModeEnabled = _useFeaturesContext.isHTTPModeEnabled;

  var _useAppSelector2 = (0,store/* useAppSelector */.CG)(player/* selectPlayerState */.tA),
      radioQueue = _useAppSelector2.radioQueue,
      activeMedia = _useAppSelector2.activeMedia;

  var showStreamErrors = (0,toast_component/* useErrorToast */.cM)({
    content: t("playback-error")
  });
  var showHttpStreamErrors = (0,toast_component/* useErrorToast */.cM)({
    content: t("http-error")
  });
  var playerLogo = (0,react.useMemo)(function () {
    var defaultLogo = category.logo || "/radioline.jpg";
    return (0,model_category/* getStationLiveLogo */.ZH)(liveData === null || liveData === void 0 ? void 0 : liveData.data, defaultLogo);
  }, [category.logo, liveData === null || liveData === void 0 ? void 0 : liveData.data]);
  var miniLogo = (0,react.useMemo)(function () {
    return (0,model_category/* getStationLiveLogo */.ZH)(liveData === null || liveData === void 0 ? void 0 : liveData.data, category.logo);
  }, [category.logo, liveData === null || liveData === void 0 ? void 0 : liveData.data]);
  var stationTitle = (0,react.useMemo)(function () {
    return liveData !== null && liveData !== void 0 && liveData.data ? (0,model_category/* getStationTitle */.tw)(liveData.data, category.name) : category.name;
  }, [liveData === null || liveData === void 0 ? void 0 : (_liveData$data$body = liveData.data.body) === null || _liveData$data$body === void 0 ? void 0 : (_liveData$data$body$c = _liveData$data$body.content) === null || _liveData$data$body$c === void 0 ? void 0 : (_liveData$data$body$c2 = _liveData$data$body$c.show) === null || _liveData$data$body$c2 === void 0 ? void 0 : _liveData$data$body$c2.name, liveData === null || liveData === void 0 ? void 0 : (_liveData$data$body2 = liveData.data.body) === null || _liveData$data$body2 === void 0 ? void 0 : (_liveData$data$body2$ = _liveData$data$body2.content) === null || _liveData$data$body2$ === void 0 ? void 0 : (_liveData$data$body2$2 = _liveData$data$body2$.track) === null || _liveData$data$body2$2 === void 0 ? void 0 : _liveData$data$body2$2.name, category.name]);
  var artistName = (0,react.useMemo)(function () {
    return liveData !== null && liveData !== void 0 && liveData.data ? (0,model_category/* getArtistName */.n6)(liveData.data) : undefined;
  }, [liveData === null || liveData === void 0 ? void 0 : (_liveData$data$body3 = liveData.data.body) === null || _liveData$data$body3 === void 0 ? void 0 : (_liveData$data$body3$ = _liveData$data$body3.content) === null || _liveData$data$body3$ === void 0 ? void 0 : (_liveData$data$body3$2 = _liveData$data$body3$.track) === null || _liveData$data$body3$2 === void 0 ? void 0 : (_liveData$data$body3$3 = _liveData$data$body3$2.artist) === null || _liveData$data$body3$3 === void 0 ? void 0 : _liveData$data$body3$3.name]);
  var subtitle = (0,react.useMemo)(function () {
    var _liveData$data, _liveData$data$body4, _liveData$data$body4$, _liveData$data$body4$2, _liveData$data3, _liveData$data3$body, _liveData$data3$body$, _liveData$data3$body$2, _liveData$data3$body$3, _liveData$data4, _liveData$data4$body, _liveData$data4$body$, _liveData$data4$body$2;

    if (liveData !== null && liveData !== void 0 && (_liveData$data = liveData.data) !== null && _liveData$data !== void 0 && (_liveData$data$body4 = _liveData$data.body) !== null && _liveData$data$body4 !== void 0 && (_liveData$data$body4$ = _liveData$data$body4.content) !== null && _liveData$data$body4$ !== void 0 && (_liveData$data$body4$2 = _liveData$data$body4$.show) !== null && _liveData$data$body4$2 !== void 0 && _liveData$data$body4$2.name) {
      var _liveData$data2, _liveData$data2$body, _liveData$data2$body$, _liveData$data2$body$2;

      return liveData === null || liveData === void 0 ? void 0 : (_liveData$data2 = liveData.data) === null || _liveData$data2 === void 0 ? void 0 : (_liveData$data2$body = _liveData$data2.body) === null || _liveData$data2$body === void 0 ? void 0 : (_liveData$data2$body$ = _liveData$data2$body.content) === null || _liveData$data2$body$ === void 0 ? void 0 : (_liveData$data2$body$2 = _liveData$data2$body$.show) === null || _liveData$data2$body$2 === void 0 ? void 0 : _liveData$data2$body$2.name;
    }

    if (liveData !== null && liveData !== void 0 && (_liveData$data3 = liveData.data) !== null && _liveData$data3 !== void 0 && (_liveData$data3$body = _liveData$data3.body) !== null && _liveData$data3$body !== void 0 && (_liveData$data3$body$ = _liveData$data3$body.content) !== null && _liveData$data3$body$ !== void 0 && (_liveData$data3$body$2 = _liveData$data3$body$.track) !== null && _liveData$data3$body$2 !== void 0 && (_liveData$data3$body$3 = _liveData$data3$body$2.artist) !== null && _liveData$data3$body$3 !== void 0 && _liveData$data3$body$3.name && liveData !== null && liveData !== void 0 && (_liveData$data4 = liveData.data) !== null && _liveData$data4 !== void 0 && (_liveData$data4$body = _liveData$data4.body) !== null && _liveData$data4$body !== void 0 && (_liveData$data4$body$ = _liveData$data4$body.content) !== null && _liveData$data4$body$ !== void 0 && (_liveData$data4$body$2 = _liveData$data4$body$.track) !== null && _liveData$data4$body$2 !== void 0 && _liveData$data4$body$2.name) {
      var _liveData$data5, _liveData$data5$body, _liveData$data5$body$, _liveData$data5$body$2, _liveData$data5$body$3, _liveData$data6, _liveData$data6$body, _liveData$data6$body$, _liveData$data6$body$2;

      return "".concat(liveData === null || liveData === void 0 ? void 0 : (_liveData$data5 = liveData.data) === null || _liveData$data5 === void 0 ? void 0 : (_liveData$data5$body = _liveData$data5.body) === null || _liveData$data5$body === void 0 ? void 0 : (_liveData$data5$body$ = _liveData$data5$body.content) === null || _liveData$data5$body$ === void 0 ? void 0 : (_liveData$data5$body$2 = _liveData$data5$body$.track) === null || _liveData$data5$body$2 === void 0 ? void 0 : (_liveData$data5$body$3 = _liveData$data5$body$2.artist) === null || _liveData$data5$body$3 === void 0 ? void 0 : _liveData$data5$body$3.name, " - ").concat(liveData === null || liveData === void 0 ? void 0 : (_liveData$data6 = liveData.data) === null || _liveData$data6 === void 0 ? void 0 : (_liveData$data6$body = _liveData$data6.body) === null || _liveData$data6$body === void 0 ? void 0 : (_liveData$data6$body$ = _liveData$data6$body.content) === null || _liveData$data6$body$ === void 0 ? void 0 : (_liveData$data6$body$2 = _liveData$data6$body$.track) === null || _liveData$data6$body$2 === void 0 ? void 0 : _liveData$data6$body$2.name);
    }

    return "";
  }, [liveData === null || liveData === void 0 ? void 0 : (_liveData$data7 = liveData.data) === null || _liveData$data7 === void 0 ? void 0 : (_liveData$data7$body = _liveData$data7.body) === null || _liveData$data7$body === void 0 ? void 0 : _liveData$data7$body.content]);
  var artwork = (0,react.useMemo)(function () {
    return [{
      src: playerLogo,
      sizes: "96x96",
      type: "image/png"
    }, {
      src: playerLogo,
      sizes: "128x128",
      type: "image/png"
    }, {
      src: playerLogo,
      sizes: "192x192",
      type: "image/png"
    }, {
      src: playerLogo,
      sizes: "256x256",
      type: "image/png"
    }, {
      src: playerLogo,
      sizes: "384x384",
      type: "image/png"
    }, {
      src: playerLogo,
      sizes: "512x512",
      type: "image/png"
    }];
  }, [playerLogo]);

  var _useFavorites = (0,favorites_hook/* useFavorites */.r)(),
      isFavoriteCategory = _useFavorites.isFavoriteCategory,
      addToFavorites = _useFavorites.addToFavorites,
      removeFromFavorites = _useFavorites.removeFromFavorites;

  var httpModeToast = (0,toast_component/* useToast */.pm)({
    content: "Updating the player..."
  });

  var goToHTTPPlayer = function goToHTTPPlayer() {
    httpModeToast();
    console.log("goToHTTPPlayer", "http://".concat(window.location.host, "/player/").concat(category.permalink)); // switch to http mode and open new window

    if (true) {
      window.location.href = "http://".concat(window.location.host, "/player/").concat(category.permalink); // PROD
      // window.location.href = `http://localhost:3000/player/${category.permalink}`; // DEV
    }
  };

  var backToHTTPS = function backToHTTPS() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "close";
    console.log("backToHTTPS");
    httpModeToast();
    var url = "https://".concat(window.location.host, "/"); // PROD
    // let url = `https://localhost:3001/`; // DEV

    if (mode === "close") {
      url += "".concat(category.permalink, "#pause");
    } else if (mode === "next") {
      url += "".concat(category.permalink, "#next");
    } else if (mode === "prev") {
      url += "".concat(category.permalink, "#prev");
    } //redirect


    window.location.href = url;
  };

  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    var hash = router.asPath.split("#")[1];

    if (hash && hash === "pause") {
      setPlayerEnabled(false);
      setPlayerOpen(false);
      setIsPlaying(false);
      controls.pause();

      if (radioQueue.items.length > 0) {
        // play other radio
        onNextTrack();
      } else {
        // empty the player
        dispatch(player/* playerActions.selectTrack */.i9.selectTrack(null));
      }
    } else if (hash && hash === "next") {
      onNextTrack();
      setPlayerEnabled(true);
      setPlayerOpen(true);
    } else if (hash && hash === "prev") {
      onPreviousTrack();
      setPlayerEnabled(true);
      setPlayerOpen(true);
    }

    if (true) {
      window.location.hash = "";
    }
  }, [router.asPath]);

  var onPlaybackError = function onPlaybackError() {
    var isHttps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    console.log("onPlaybackError", isHttps, isHTTPModeEnabled, httpMode);

    if (!isHttps) {
      if (isHTTPModeEnabled && !httpMode) {
        goToHTTPPlayer();
      } else {
        showHttpStreamErrors();
      }
    } else {
      showStreamErrors();
    }

    if (category.permalink) {
      dispatch(player/* playerActions.setFailedPlaybackPermalink */.i9.setFailedPlaybackPermalink(category.permalink));
    }
  };

  (0,react.useEffect)(function () {
    if (streamsLoadError) {
      showStreamErrors();
    }
  }, [streamsLoadError]);
  var isCurrentCategoryFavorite = isFavoriteCategory(category);

  var onAdStreamEnd = function onAdStreamEnd() {
    sendTargetspotTrackingEvent(audioAds/* TargetspotEventType.Complete */.q3.Complete);
    dispatch(user/* userActions.setLastAdTimestamp */.hI.setLastAdTimestamp(new Date()));
  };

  var onPreviousTrack = function onPreviousTrack() {
    if (radioQueue.items.length > 0 && radioQueue.activeIndex !== null) {
      if (radioQueue.activeIndex > 0) {
        dispatch(player/* playerActions.setRadioQueue */.i9.setRadioQueue({
          items: radioQueue.items,
          activeIndex: radioQueue.activeIndex - 1
        }));
      } else {
        dispatch(player/* playerActions.setRadioQueue */.i9.setRadioQueue({
          items: radioQueue.items,
          activeIndex: radioQueue.items.length - 1
        }));
      }
    }

    if (httpMode) {
      backToHTTPS("prev");
    }
  };

  var onNextTrack = function onNextTrack() {
    if (radioQueue.items.length > 0 && radioQueue.activeIndex !== null) {
      if (radioQueue.activeIndex < radioQueue.items.length - 1) {
        dispatch(player/* playerActions.setRadioQueue */.i9.setRadioQueue({
          items: radioQueue.items,
          activeIndex: radioQueue.activeIndex + 1
        }));
      } else {
        dispatch(player/* playerActions.setRadioQueue */.i9.setRadioQueue({
          items: radioQueue.items,
          activeIndex: 0
        }));
      }
    }

    if (httpMode) {
      backToHTTPS("prev");
    }
  };

  var onFavoriteToggle = function onFavoriteToggle(enabled) {
    if (enabled) {
      setCategoryToAddToFavorites(category);
    } else {
      setCategoryToRemoveFromFavorites(category);
    }
  };

  var onPlay = function onPlay() {
    setPlayerEnabled(true); // startAudioDotAdPlayback();
  };

  var _useAppAudio = (0,audio_hook/* default */.Z)({
    artist: artistName,
    artwork: artwork,
    title: stationTitle,
    isFavorite: isCurrentCategoryFavorite,
    favoritesEnabled: !!(session !== null && session !== void 0 && session.user),
    streamType: "radio",
    audioProps: {
      onPlay: onPlay
    },
    streams: streams,
    adStreams: adStreams,
    streamsLoading: streamsLoading,
    autoplay: playerEnabled,
    onPlaybackError: onPlaybackError,
    onAdStreamEnd: onAdStreamEnd,
    onNextTrack: onNextTrack,
    onFavoriteToggle: onFavoriteToggle,
    onPreviousTrack: onPreviousTrack,
    liveStream: true,
    permalink: category.permalink
  }, [category.permalink]),
      audioElement = _useAppAudio.audioElement,
      fallbackAudioElement = _useAppAudio.fallbackAudioElement,
      state = _useAppAudio.state,
      controls = _useAppAudio.controls;

  (0,react.useEffect)(function () {
    var _state$activeStream, _state$activeStream$u;

    if (httpMode && (_state$activeStream = state.activeStream) !== null && _state$activeStream !== void 0 && (_state$activeStream$u = _state$activeStream.url) !== null && _state$activeStream$u !== void 0 && _state$activeStream$u.startsWith("https")) {
      // we are in http mode but the stream is https - switch back to https
      backToHTTPS();
    }
  }, [(_state$activeStream2 = state.activeStream) === null || _state$activeStream2 === void 0 ? void 0 : _state$activeStream2.url, httpMode]);
  (0,useInterval/* default */.Z)(function () {
    if (state.activeAdStream && state.playing) {
      sendTargetspotTimeUpdateEvent(state);
    }
  }, 5000);

  var _useState2 = (0,react.useState)(null),
      categoryToAddToFavorites = _useState2[0],
      setCategoryToAddToFavorites = _useState2[1];

  (0,react.useEffect)(function () {
    if (categoryToAddToFavorites) {
      addToFavorites(categoryToAddToFavorites, isPlaying);
      setCategoryToAddToFavorites(null);
    }
  }, [categoryToAddToFavorites]);

  var _useState3 = (0,react.useState)(null),
      categoryToRemoveFromFavorites = _useState3[0],
      setCategoryToRemoveFromFavorites = _useState3[1];

  (0,react.useEffect)(function () {
    if (categoryToRemoveFromFavorites) {
      removeFromFavorites(categoryToRemoveFromFavorites, isPlaying);
      setCategoryToRemoveFromFavorites(null);
    }
  }, [categoryToRemoveFromFavorites]);
  var pausedRefetchCounter = (0,react.useRef)(0);
  var pausedRefetchDebounceAmount = 2;
  (0,useInterval/* default */.Z)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var liveLiveData;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!category.permalink) {
              _context.next = 15;
              break;
            }

            if (!state.playing) {
              _context.next = 13;
              break;
            }

            _context.prev = 2;
            _context.next = 5;
            return (0,services/* getPillowRadioLive */.Lg)(category.permalink, {
              isPlaying: state.playing
            });

          case 5:
            liveLiveData = _context.sent;
            setLiveData(liveLiveData);
            _context.next = 11;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);

          case 11:
            _context.next = 15;
            break;

          case 13:
            // debounce the call when paused
            pausedRefetchCounter.current++;

            if (pausedRefetchCounter.current > pausedRefetchDebounceAmount) {
              refetch();
              pausedRefetchCounter.current = 0;
            }

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 9]]);
  })), refetchMetadataInterval); // update UI on data change

  (0,react.useEffect)(function () {
    setLiveData(updatedLiveData);
  }, [updatedLiveData]);
  (0,react.useEffect)(function () {
    if (radioQueue.activeIndex !== null && radioQueue.items[radioQueue.activeIndex] && radioQueue.items[radioQueue.activeIndex].permalink !== category.permalink) {
      dispatch(player/* playerActions.selectTrack */.i9.selectTrack({
        podcast: null,
        category: radioQueue.items[radioQueue.activeIndex]
      }));
    }
  }, [radioQueue, category]);
  var showOfflineError = (0,toast_component/* useErrorToast */.cM)({
    content: t("network.connection-lost")
  });
  (0,react.useEffect)(function () {
    if (!window.navigator.onLine) {
      showOfflineError();
    }
  }, [category.permalink]);
  (0,react.useEffect)(function () {
    if (playerEnabled && fullscreenPlayerInitialyOpen) {
      setPlayerOpen(true);
      setFullscreenPlayerInitialyOpen(false);
    }
  }, [category.permalink, fullscreenPlayerInitialyOpen]);
  var playerVariables = {
    "--image-background": "url(".concat(playerLogo !== null && playerLogo !== void 0 ? playerLogo : "/gradient.jpg", ")")
  };

  var goToDetails = function goToDetails() {
    navigatePath("/".concat(category.permalink));
    setPlayerOpen(false);
  };

  (0,spacebar_hook/* useSpacebarEvent */.G)(function () {
    return controls.toggle();
  });
  (0,react.useEffect)(function () {
    setIsMediaLoading(state.loading);
  }, [state.loading]);
  (0,react.useEffect)(function () {
    if (isPlaying && !state.playing) {
      controls.play();
    }

    if (!isPlaying && state.playing) {
      controls.pause();
    }
  }, [isPlaying]);
  (0,react.useEffect)(function () {
    setIsPlaying(state.playing);
    (0,services/* getPillowRadioLive */.Lg)(category.permalink, {
      isPlaying: state.playing
    }).catch(function (e) {
      return console.log("Could not load live data");
    });

    if (state.playing) {
      dispatch(player/* playerActions.setFailedPlaybackPermalink */.i9.setFailedPlaybackPermalink(null));
    } else {
      pausedRefetchCounter.current = 0;
    }

    if (state.activeAdStream) {
      sendTargetspotStateUpdateEvent(state);
    }
  }, [state.playing]);
  (0,react.useEffect)(function () {
    if (radioQueue.activeIndex !== null) {
      if (radioQueue.activeIndex === radioQueue.items.length - 1) {
        try {
          var queryNextInfo = hooks/* useGetPillowRadioLive.info */.pE.info(radioQueue.items[0].permalink, {
            isPlaying: false
          });
          var queryPrevInfo = hooks/* useGetPillowRadioLive.info */.pE.info(radioQueue.items[radioQueue.activeIndex - 1].permalink, {
            isPlaying: false
          });
          queryClient.prefetchQuery(queryPrevInfo.key, function () {
            return queryPrevInfo.fun();
          });
          queryClient.prefetchQuery(queryNextInfo.key, function () {
            return queryNextInfo.fun();
          });
        } catch (e) {}
      } else if (radioQueue.activeIndex === 0) {
        try {
          var _queryNextInfo = hooks/* useGetPillowRadioLive.info */.pE.info(radioQueue.items[1].permalink, {
            isPlaying: false
          });

          var _queryPrevInfo = hooks/* useGetPillowRadioLive.info */.pE.info(radioQueue.items[radioQueue.items.length - 1].permalink, {
            isPlaying: false
          });

          queryClient.prefetchQuery(_queryPrevInfo.key, function () {
            return _queryPrevInfo.fun();
          });
          queryClient.prefetchQuery(_queryNextInfo.key, function () {
            return _queryNextInfo.fun();
          });
        } catch (e) {}
      } else {
        try {
          var _queryNextInfo2 = hooks/* useGetPillowRadioLive.info */.pE.info(radioQueue.items[radioQueue.activeIndex + 1].permalink, {
            isPlaying: false
          });

          var _queryPrevInfo2 = hooks/* useGetPillowRadioLive.info */.pE.info(radioQueue.items[radioQueue.activeIndex - 1].permalink, {
            isPlaying: false
          });

          queryClient.prefetchQuery(_queryPrevInfo2.key, function () {
            return _queryPrevInfo2.fun();
          });
          queryClient.prefetchQuery(_queryNextInfo2.key, function () {
            return _queryNextInfo2.fun();
          });
        } catch (e) {}
      }
    }
  }, [radioQueue]);
  var closePlayerCallback = (0,react.useCallback)(function () {
    return setPlayerOpen(false);
  }, [setPlayerOpen]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (player_module_default()).content_wrapper,
      style: playerVariables,
      onClick: function onClick() {
        return setPlayerOpen(true);
      },
      tabIndex: 0,
      "data-navigate-item": true,
      children: [audioElement, fallbackAudioElement, /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (player_module_default()).content,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (player_module_default()).track_info,
          children: [miniLogo ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            className: (player_module_default()).cover_img,
            src: miniLogo,
            alt: ""
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)((player_module_default()).cover_img, (player_module_default()).placeholder),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Wave/* default */.Z, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (player_module_default()).track_title,
              children: category.name
            }), subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (player_module_default()).track_subtitle,
              children: subtitle
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (player_module_default()).track_controls,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: (player_module_default()).play_pause_icon,
            onClick: function onClick(e) {
              if (streamsLoadError) {
                refetchStreams();
              } else {
                controls.toggle();
              }

              e.stopPropagation();
            },
            children: !streamsLoadError && (state.loading || streamsLoading) ? /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : state.playing ? /*#__PURE__*/(0,jsx_runtime.jsx)(Pause/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(Play/* default */.Z, {})
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PlayerFullScreen, {
      open: playerOpen,
      category: category,
      cover: playerLogo,
      playbackControls: controls,
      playbackState: state,
      categoryMetadata: liveData === null || liveData === void 0 ? void 0 : liveData.data,
      playerCssVariables: playerVariables,
      onClose: closePlayerCallback,
      goToDetails: goToDetails,
      backToHTTPS: backToHTTPS
    })]
  });
};
// EXTERNAL MODULE: ./app/ts.ts
var ts = __webpack_require__(38448);
;// CONCATENATED MODULE: ./app/components/station-player/player-wrapper.component.tsx













var PlayerWrapper = function PlayerWrapper() {
  var _useState = (0,react.useState)(false),
      playerOpen = _useState[0],
      setPlayerOpen = _useState[1];

  var _useAppSelector = (0,store/* useAppSelector */.CG)(player/* selectPlayerState */.tA),
      activeMedia = _useAppSelector.activeMedia;

  var activeCategory = activeMedia === null || activeMedia === void 0 ? void 0 : activeMedia.category;
  return activeCategory ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,clsx_m/* default */.Z)((player_module_default()).wrapper),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PlayerStreamsLoader, {
        category: activeCategory,
        playerOpen: playerOpen,
        setPlayerOpen: setPlayerOpen
      })
    })
  }) : null;
};

var PlayerStreamsLoader = function PlayerStreamsLoader(_ref) {
  var category = _ref.category,
      playerOpen = _ref.playerOpen,
      setPlayerOpen = _ref.setPlayerOpen;

  var _useAppSelector2 = (0,store/* useAppSelector */.CG)(player/* selectPlayerState */.tA),
      radioQueue = _useAppSelector2.radioQueue;

  var _useGetPillowRadioPla = (0,hooks/* useGetPillowRadioPlay */.jN)(category.permalink, {
    keepPreviousData: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false
  }),
      streamsData = _useGetPillowRadioPla.data,
      streamsLoading = _useGetPillowRadioPla.isLoading,
      isError = _useGetPillowRadioPla.isError,
      refetch = _useGetPillowRadioPla.refetch;

  var queryClient = (0,es.useQueryClient)();
  (0,react.useEffect)(function () {
    if (radioQueue.activeIndex !== null) {
      if (radioQueue.activeIndex === radioQueue.items.length - 1) {
        try {
          var queryNextInfo = hooks/* useGetPillowRadioPlay.info */.jN.info(radioQueue.items[0].permalink);
          var queryPrevInfo = hooks/* useGetPillowRadioPlay.info */.jN.info(radioQueue.items[radioQueue.activeIndex - 1].permalink);
          queryClient.prefetchQuery(queryPrevInfo.key, queryPrevInfo.fun);
          queryClient.prefetchQuery(queryNextInfo.key, queryNextInfo.fun);
        } catch (e) {}
      } else if (radioQueue.activeIndex === 0) {
        try {
          var _queryNextInfo = hooks/* useGetPillowRadioPlay.info */.jN.info(radioQueue.items[1].permalink);

          var _queryPrevInfo = hooks/* useGetPillowRadioPlay.info */.jN.info(radioQueue.items[radioQueue.items.length - 1].permalink);

          queryClient.prefetchQuery(_queryPrevInfo.key, _queryPrevInfo.fun);
          queryClient.prefetchQuery(_queryNextInfo.key, _queryNextInfo.fun);
        } catch (e) {}
      } else {
        try {
          var _queryNextInfo2 = hooks/* useGetPillowRadioPlay.info */.jN.info(radioQueue.items[radioQueue.activeIndex + 1].permalink);

          var _queryPrevInfo2 = hooks/* useGetPillowRadioPlay.info */.jN.info(radioQueue.items[radioQueue.activeIndex - 1].permalink);

          queryClient.prefetchQuery(_queryPrevInfo2.key, _queryPrevInfo2.fun);
          queryClient.prefetchQuery(_queryNextInfo2.key, _queryNextInfo2.fun);
        } catch (e) {}
      }
    }
  }, [radioQueue]);
  var streams = (0,react.useMemo)(function () {
    var _streamsData$data, _streamsData$data$bod, _streamsData$data$bod2, _streamsData$data$bod3;

    return (streamsData === null || streamsData === void 0 ? void 0 : (_streamsData$data = streamsData.data) === null || _streamsData$data === void 0 ? void 0 : (_streamsData$data$bod = _streamsData$data.body) === null || _streamsData$data$bod === void 0 ? void 0 : (_streamsData$data$bod2 = _streamsData$data$bod.content) === null || _streamsData$data$bod2 === void 0 ? void 0 : (_streamsData$data$bod3 = _streamsData$data$bod2.streams) === null || _streamsData$data$bod3 === void 0 ? void 0 : _streamsData$data$bod3.filter(ts/* notEmpty */.Dw).sort(function (streamA, streamB) {
      return (streamB.bitrate || 0) - (streamA.bitrate || 0);
    })) || [];
  }, [streamsData, category.permalink]);

  var _useAudioAds = (0,audioAds/* useAudioAds */.BZ)(category),
      adStreams = _useAudioAds.adStreams,
      adStreamsLoading = _useAudioAds.adStreamsLoading,
      sendTargetspotTimeUpdateEvent = _useAudioAds.sendTargetspotTimeUpdateEvent,
      sendTrackingEvent = _useAudioAds.sendTrackingEvent,
      sendTargetspotStateUpdateEvent = _useAudioAds.sendTargetspotStateUpdateEvent;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StationPlayer, {
    category: category,
    playerOpen: playerOpen,
    streamsLoadError: isError,
    refetchStreams: refetch,
    setPlayerOpen: setPlayerOpen,
    streams: streams,
    adStreams: adStreams,
    streamsLoading: streamsLoading || adStreamsLoading,
    sendTargetspotTimeUpdateEvent: sendTargetspotTimeUpdateEvent,
    sendTargetspotTrackingEvent: sendTrackingEvent,
    sendTargetspotStateUpdateEvent: sendTargetspotStateUpdateEvent
  });
};

/* harmony default export */ var player_wrapper_component = (PlayerWrapper);

/***/ }),

/***/ 99845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ StationsRow; }
/* harmony export */ });
/* harmony import */ var _data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59499);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var _stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98215);
/* harmony import */ var _stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _icons_Logo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23583);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80621);
/* harmony import */ var app_utils_is_mobile_resolution__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26089);
/* harmony import */ var app_store_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4062);
/* harmony import */ var app_store_slices_radio__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49624);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);













var StationsRow = function StationsRow(_ref) {
  var _clsx;

  var items = _ref.items,
      wrapped = _ref.wrapped,
      showStationNames = _ref.showStationNames,
      handleOnClick = _ref.handleOnClick,
      scrollSyncId = _ref.scrollSyncId,
      navigationDisabled = _ref.navigationDisabled,
      _ref$fetchNextPage = _ref.fetchNextPage,
      fetchNextPage = _ref$fetchNextPage === void 0 ? function () {} : _ref$fetchNextPage,
      triggerFetchNextPage = _ref.triggerFetchNextPage,
      _ref$navigateStation = _ref.navigateStation,
      navigateStation = _ref$navigateStation === void 0 ? false : _ref$navigateStation,
      column = _ref.column;
  var dispatch = (0,app_store_store__WEBPACK_IMPORTED_MODULE_3__/* .useAppDispatch */ .TL)();
  var loadMoreTriggerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var intersection = (0,react_use__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(loadMoreTriggerRef, {
    rootMargin: "0px",
    threshold: 1
  });
  var isMobile = (0,app_utils_is_mobile_resolution__WEBPACK_IMPORTED_MODULE_8__/* .useIsMobileResolution */ .zO)();

  var onLinkClick = function onLinkClick(radioStation) {
    dispatch(app_store_slices_radio__WEBPACK_IMPORTED_MODULE_4__/* .radioActions.selectRadio */ .xF.selectRadio({
      section: items,
      activeIndex: items.indexOf(radioStation)
    }));
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (triggerFetchNextPage && intersection !== null && intersection !== void 0 && intersection.isIntersecting) {
      fetchNextPage();
    }
  }, [intersection, triggerFetchNextPage]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().row), (_clsx = {}, (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_clsx, (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().vertical), column), (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_clsx, (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().wrapped), wrapped), _clsx)),
    "data-navigate-row": !navigationDisabled,
    "data-navigate-scrollable": true,
    "data-navigate-scrollable-parent": true,
    "data-sync-scroll-position": scrollSyncId,
    children: [items.map(function (radioStation, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        "data-navigate-row": !navigationDisabled && column,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
          href: "/".concat(radioStation.permalink),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("a", {
            "data-navigate-item": !navigationDisabled,
            tabIndex: 0,
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().radio_station), (0,_data_apps_www_www_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().show_station_names), showStationNames)),
            onClick: function onClick(e) {
              if (navigateStation) {
                onLinkClick(radioStation);
              } else {
                e.preventDefault();
                handleOnClick(radioStation, items.indexOf(radioStation));
              }
            },
            children: [radioStation !== null && radioStation !== void 0 && radioStation.logo || radioStation !== null && radioStation !== void 0 && radioStation.logo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
              className: (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().cover),
              src: (radioStation === null || radioStation === void 0 ? void 0 : radioStation.logo) || (radioStation === null || radioStation === void 0 ? void 0 : radioStation.logo) || "",
              width: isMobile ? 96 : 156,
              height: isMobile ? 96 : 156,
              layout: "fixed",
              objectFit: "cover",
              alt: radioStation.name,
              unoptimized: true
            }, "radio-station-".concat(index, "-").concat(radioStation.permalink)) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().cover), (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().no_image)),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_icons_Logo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
            }), showStationNames && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: (_stations_list_module_scss__WEBPACK_IMPORTED_MODULE_10___default().station_title),
              children: radioStation.name
            })]
          })
        }, "radio-station-wrap-".concat(index, "-").concat(radioStation.permalink))
      }, "station-row-".concat(index, "-").concat(radioStation.permalink));
    }), triggerFetchNextPage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      ref: loadMoreTriggerRef
    })]
  });
};

/***/ }),

/***/ 26089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vl": function() { return /* binding */ useIsLargeDesktopResolution; },
  "zO": function() { return /* binding */ useIsMobileResolution; }
});

// UNUSED EXPORTS: useIsSmallDesktopResolution

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-use/esm/misc/util.js
var util = __webpack_require__(76362);
;// CONCATENATED MODULE: ./node_modules/react-use/esm/useMedia.js


var getInitialState = function (query, defaultState) {
    // Prevent a React hydration mismatch when a default value is provided by not defaulting to window.matchMedia(query).matches.
    if (defaultState !== undefined) {
        return defaultState;
    }
    if (util/* isBrowser */.jU) {
        return window.matchMedia(query).matches;
    }
    // A default value has not been provided, and you are rendering on the server, warn of a possible hydration mismatch when defaulting to false.
    if (false) {}
    return false;
};
var useMedia_useMedia = function (query, defaultState) {
    var _a = (0,react.useState)(getInitialState(query, defaultState)), state = _a[0], setState = _a[1];
    (0,react.useEffect)(function () {
        var mounted = true;
        var mql = window.matchMedia(query);
        var onChange = function () {
            if (!mounted) {
                return;
            }
            setState(!!mql.matches);
        };
        mql.addListener(onChange);
        setState(mql.matches);
        return function () {
            mounted = false;
            mql.removeListener(onChange);
        };
    }, [query]);
    return state;
};
/* harmony default export */ var esm_useMedia = (useMedia_useMedia);

;// CONCATENATED MODULE: ./app/utils/is-mobile-resolution.ts

var useIsMobileResolution = function useIsMobileResolution() {
  return esm_useMedia('(max-width: 768px)');
};
var useIsSmallDesktopResolution = function useIsSmallDesktopResolution() {
  return useMedia('(max-width: 1281px)');
};
var useIsLargeDesktopResolution = function useIsLargeDesktopResolution() {
  return esm_useMedia('(min-width: 1920px)');
};

/***/ }),

/***/ 54825:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wave":"Wave_wave__feeJT","path":"Wave_path__J3SuJ","pulse":"Wave_pulse__HVwY5"};

/***/ }),

/***/ 15786:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","player_fullscreen_close":"player-fullscreen_player_fullscreen_close__l7GyM","button_priamry":"player-fullscreen_button_priamry__ETdiz","button_secondary":"player-fullscreen_button_secondary__5AOSW","play":"player-fullscreen_play__0r7SA","player_sidebar_enter_active":"player-fullscreen_player_sidebar_enter_active__d5_WA","player_sidebar_exit_active":"player-fullscreen_player_sidebar_exit_active__IaoxG","player_fullscreen_enter_active":"player-fullscreen_player_fullscreen_enter_active__kzXsJ","player_fullscreen_exit_active":"player-fullscreen_player_fullscreen_exit_active__eePau","player_fullscreen_controls":"player-fullscreen_player_fullscreen_controls__WK68q","player_sidebar":"player-fullscreen_player_sidebar__NaEZk","stations_row":"player-fullscreen_stations_row__0jJDs","player_sidebar_inner":"player-fullscreen_player_sidebar_inner__nxXob","player_sidebar_enter":"player-fullscreen_player_sidebar_enter__vutVQ","player_sidebar_enter_done":"player-fullscreen_player_sidebar_enter_done__YkqHv","player_sidebar_exit":"player-fullscreen_player_sidebar_exit__cgz5X","player_sidebar_exit_done":"player-fullscreen_player_sidebar_exit_done__5Pjfq","queue_item":"player-fullscreen_queue_item__jA2kN","queue_item_name":"player-fullscreen_queue_item_name__cNc4G","queue_item_duration":"player-fullscreen_queue_item_duration__Wdi8p","invisible":"player-fullscreen_invisible__vo6w8","player_fullscreen":"player-fullscreen_player_fullscreen__JUIeQ","player_fullscreen_enter":"player-fullscreen_player_fullscreen_enter__ypaH0","player_fullscreen_enter_done":"player-fullscreen_player_fullscreen_enter_done__fpTY2","player_fullscreen_exit":"player-fullscreen_player_fullscreen_exit__VCvSS","player_fullscreen_exit_done":"player-fullscreen_player_fullscreen_exit_done__do8Kd","player_fullscreen_wrapper":"player-fullscreen_player_fullscreen_wrapper__5FV_h","player_fullscreen_content":"player-fullscreen_player_fullscreen_content__OxWWA","player_fullscreen_inner":"player-fullscreen_player_fullscreen_inner__1zRIw","player_fullscreen_header":"player-fullscreen_player_fullscreen_header__QPzbd","player_logo":"player-fullscreen_player_logo__GLaMj","ad_visible":"player-fullscreen_ad_visible__QkBMm","video_ad_header":"player-fullscreen_video_ad_header__Atejs","player_fullscreen_track":"player-fullscreen_player_fullscreen_track__9ISSh","player_fullscreen_track_info_ads":"player-fullscreen_player_fullscreen_track_info_ads__m64Uz","video_ad_active":"player-fullscreen_video_ad_active__1tCfJ","player_fullscreen_track_info":"player-fullscreen_player_fullscreen_track_info__zx7Cg","show_name":"player-fullscreen_show_name__1ux9Z","video_ad":"player-fullscreen_video_ad__11Gow","ad_header":"player-fullscreen_ad_header__X4QeP","ad_player":"player-fullscreen_ad_player__TA4iP","video_ad_ready":"player-fullscreen_video_ad_ready__LlJgt","title":"player-fullscreen_title__yShM_","track_name":"player-fullscreen_track_name__dFXkA","track_artist":"player-fullscreen_track_artist__49er4","add_to_playlist_icon":"player-fullscreen_add_to_playlist_icon__AW2x2","vlyby_container":"player-fullscreen_vlyby_container__NfJHb"};

/***/ }),

/***/ 28635:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","audio_player":"player_audio_player__G6jKe","content_wrapper":"player_content_wrapper__SwXKo","wrapper":"player_wrapper__jvwkR","content":"player_content__jtMSk","track_info":"player_track_info__SvENk","cover_img":"player_cover_img__49tV3","placeholder":"player_placeholder__uAvRu","track_title":"player_track_title__nWFV7","track_subtitle":"player_track_subtitle___zFBV","track_controls":"player_track_controls__DPKzb","play_pause_icon":"player_play_pause_icon__JGVTN"};

/***/ }),

/***/ 98215:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","radioStationOuterWidth":"18.2rem","radioStationOuterWidthMobile":"12.2rem","wrapper":"stations-list_wrapper__EQsZ_","radio_station":"stations-list_radio_station__V7ZFQ","header":"stations-list_header__WR2Ed","placeholder_item":"stations-list_placeholder_item__S5kXd","station_title":"stations-list_station_title__6tidF","buttons":"stations-list_buttons__dgWsZ","arrow":"stations-list_arrow__hsaxX","arrow_back":"stations-list_arrow_back__srxIO","radio_list":"stations-list_radio_list__nB0CT","cover_wrapper":"stations-list_cover_wrapper__LLHG3","cover":"stations-list_cover__OEgIg","no_image":"stations-list_no_image__3biBe","show_station_names":"stations-list_show_station_names__aW01m","row":"stations-list_row__v4ZLU","vertical":"stations-list_vertical__rnn2R","wrapped":"stations-list_wrapped__lUsyl","load":"stations-list_load__gmj9g"};

/***/ }),

/***/ 80621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useIntersection = function (ref, options) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), intersectionObserverEntry = _a[0], setIntersectionObserverEntry = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (ref.current && typeof IntersectionObserver === 'function') {
            var handler = function (entries) {
                setIntersectionObserverEntry(entries[0]);
            };
            var observer_1 = new IntersectionObserver(handler, options);
            observer_1.observe(ref.current);
            return function () {
                setIntersectionObserverEntry(null);
                observer_1.disconnect();
            };
        }
        return function () { };
    }, [ref.current, options.threshold, options.root, options.rootMargin]);
    return intersectionObserverEntry;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIntersection);


/***/ }),

/***/ 43337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useInterval = function (callback, delay) {
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () { });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        savedCallback.current = callback;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (delay !== null) {
            var interval_1 = setInterval(function () { return savedCallback.current(); }, delay || 0);
            return function () { return clearInterval(interval_1); };
        }
        return undefined;
    }, [delay]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useInterval);


/***/ })

}]);